import Stack from 'src/app/atoms/Layout/Stack/Stack';
import styled, { keyframes } from 'styled-components';

export const TestimonialTextBlock = styled(Stack)`
  bottom: 0;
  left: 0;
  width: 100%;

  /* Prevent flickering on Safari for sliders */
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);

  .testimonial-text-block-container {
    width: 100%;
  }
`;

const fadeInKeyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  animation: ${fadeInKeyframes} 0.3s ease-in-out;
`;

export const PlayButtonContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
`;
